import Mutations from '../../odata/mutations';

export default { ...new Mutations('feedEmOrder'), ...new Mutations('feedEmOrders') };
